export enum FileUploadKeys {
    AudioLengthSeconds = "AudioLengthSeconds",
    AudioFileSizeBytes = "AudioFileSizeBytes",
    AudioFileExtension = "AudioFileExtension",
    TotalUploadDuration = "TotalUploadDuration",
    TranscriptionProcessDuration = "TranscriptionProcessDuration",
    AddMinutesUsedDuration = "AddMinutesUsedDuration",
    FailureReason = "FailureReason",
    FrontDoorSessionId = 'FrontDoorSessionId',
    EstimatedTranscriptionTimeAsPercentageOfAudioLength = 'EstimatedTranscriptionTimeAsPercentageOfAudioLength',
    PreeliminaryAudioLengthUnavailable = 'PreeliminaryAudioLengthUnavailable',
    ServiceFileDurationSeconds = 'ServiceFileDurationSeconds',
    GetFileDurationDurationSeconds = 'GetFileDurationDurationSeconds',
    TranscriptionLocale = 'TranscriptionLocale'
};